var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { fontSizes, spacing } from 'syf-component-library/defaultTheme';
import theme from '../../../theme';
var SpecialCharacterReminder = styled.p(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  font-size: ", "px;\n  margin-top: ", "px;\n  line-height: 20px;\n"], ["\n  color: ", ";\n  font-size: ", "px;\n  margin-top: ", "px;\n  line-height: 20px;\n"])), theme.colors.dimGrey, fontSizes.small, spacing.xsmall);
export default SpecialCharacterReminder;
var templateObject_1;
//# sourceMappingURL=index.js.map